"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const cw_http_service_1 = require("@dialogexe/cw-http-service");
const actions_1 = require("./actions");
const cw_parameters_provider_1 = require("@dialogexe/cw-parameters-provider");
function* fetchEvents(action) {
    if (typeof window === 'undefined') {
        return;
    }
    const requestedIds = yield effects_1.select((state) => (state.events.requested));
    const requestableIds = action.ids.filter(id => (requestedIds.indexOf(id) === -1));
    if (requestableIds.length === 0) {
        return;
    }
    yield effects_1.put(actions_1.actionCreators.trackRequestedEvents(requestableIds));
    const request = new cw_http_service_1.Request(cw_parameters_provider_1.parametersProvider.get('api.runtime'));
    const events = yield request
        .get('events', { site: createSiteId() }, { params: { 'keys': requestableIds.join() } })
        .then((response) => {
        return response.data;
    });
    yield effects_1.put(actions_1.actionCreators.putEvents(events));
}
exports.fetchEvents = fetchEvents;
// TODO: Remove when runtime API supports list of partners as query parameter
function createSiteId() {
    const partners = cw_parameters_provider_1.parametersProvider.get('site.partners');
    return `site${partners[0]}a`;
}
function* watchFetchEventsAsync() {
    yield effects_1.takeEvery(actions_1.actions.FETCH_EVENTS, fetchEvents);
}
exports.watchFetchEventsAsync = watchFetchEventsAsync;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/events/sagas.ts